export default __webpack_public_path__ + "static/media/59.279f9173.gif";